import { userStorage } from "../_utils/userStorage.js";
import { apiFetch } from "../_utils/apiInterceptor.js";
import * as validators from "../_utils/validators.js";

const backendUrl = process.env.REACT_APP_BACKEND_URL;
const BASE_URL = `${backendUrl}/api/v1/auth`;

const validateUser = (data) => {
  if (
      !data.emailAddress || 
      !validators.isValidEmail(data.emailAddress)
    )
    throw new Error("Invalid email address");

  if (
      !data.mobileNumber || 
      !validators.isValidMobileNumber(data.mobileNumber)
    )
    throw new Error("Invalid mobile number accepted (260XXXXXXXXX)");

  if (
      validators.isEmpty(data.fullName) ||
      validators.isLongerThan(data.fullName, 50) || 
      validators.isShorterThan(data.fullName, 5)
    )
    throw new Error("Invalid name (should 5 to 50 characters)");

}
export const signUp = async (formData) => {
  validateUser(formData);

  return await apiFetch(
    `${BASE_URL}/register`, {
    method: 'POST',
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify(formData),
  });
};  

export const updatePassword = async (password) => {
  if(validators.isEmpty(password) || validators.isShorterThan(password, 7)){
    throw new Error(
      'Validation Error: Invalid password.'
    );
  }

  return await apiFetch(
    `${BASE_URL}/update-password`,
    {
      method: "POST",
      body: JSON.stringify({password}),
    }
  );
};  

export const verifyAccount = async (emailAddress) => {
  if(validators.isEmpty(emailAddress) || !validators.isValidEmail(emailAddress)){
    throw new Error(
      'Validation Error: Invalid email address.'
    );
  }

  return await apiFetch(
    `${BASE_URL}/verify-account`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({emailAddress}),
    }
  );
};  

export const verifyOTP = async (emailAddress, otp) => {
  if(validators.isEmpty(emailAddress) || !validators.isValidEmail(emailAddress)){
    throw new Error(
      'Validation Error: Invalid email address.'
    );
  }

  if(validators.isEmpty(otp) || validators.isLongerThan(otp, 6)  || validators.isShorterThan(otp, 6)){
    throw new Error(
      'Validation Error: Invalid OTP'
    );
  }

  return await apiFetch(
    `${BASE_URL}/verify-otp`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({emailAddress, otp}),
    }
  );
};  

export async function refreshAccessToken() {
  const refreshToken = userStorage.getRefreshToken();

  return await fetch(
    `${BASE_URL}/refresh-token`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        refreshToken,
      }),
    }
  );
}

export const userLogin = async (emailAddress, password) => {
  if(validators.isEmpty(emailAddress) ){
    throw new Error(
      'Validation Error: Username is required.'
    );
  }

  if(validators.isEmpty(password) ){
    throw new Error(
      'Validation Error: Password is required.'
    );
  }
  
  return await apiFetch(
    `${BASE_URL}/login`, {
    method: 'POST',
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({emailAddress, password}),
  });
};  

export const verifyToken = async (token) => {
  if (!token) {
    throw new Error('Validation Error: invalid auth token.');
  }

  return await apiFetch(
    `${BASE_URL}/open/verify`, {
    method: 'GET',
    mode: 'cors',
  });
};


export const userLogout = async () => {
  return await apiFetch(`${BASE_URL}/logout`, {
    method: 'GET',
    headers: {
      "Content-Type": "application/json"
    }
  });
};  
